import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GdprConsentService } from 'src/app/services/gdpr-consent.service';

@Component({
  selector: 'app-gdpr-consent',
  templateUrl: './gdpr-consent.component.html',
  styleUrl: './gdpr-consent.component.scss',
  standalone: false
})
export class GdprConsentComponent {
  consentChecked = false;
  testDisclaimerChecked = false;
  constructor(
    private gdprConsentService: GdprConsentService,
    public bsModalRef : BsModalRef,
  ) { }

  onClose() {
    this.gdprConsentService.registerGdprConsent(true);
    this.bsModalRef.hide();
  }
}
